module.exports = __webpack_public_path__ + "static/media/icons_Bilan de rééducation neurologique.f7c4ee7f.svg";